﻿/*-------------------------------------------------------
'   @module: HK - Image Gallery
'---------------------------------------------------------*/
import { opaccAjaxPlugin } from "./vendor/script/opacc.static.js";

export class HKImageGallery {
    constructor() {
        // selectors
        this.galleryFullscreenSelector = '.image-gallery-fullscreen';
        this.gallerySelector = '.image-gallery';
        this.thumbSelector = '.image-thumb';
        this.imageListSelector = '.image-list';
        this.imageMainSelector = '.image-main';
        this.galleryControlSelector = '.control-button';

        // actions
        this.galleryFullscreenAction = `[data-art-action="gallery-fullscreen"]`;
        this.closeFullscreenAction = `[data-art-action="close-fullscreen"]`;

        this.gallery = document.querySelectorAll(this.gallerySelector);

        this.attachEventListener();
    }

    /**
     * Attach event listeners.
     */
    attachEventListener() {
        Array.from(this.gallery).forEach(gallery => {
            gallery.addEventListener('click', e => {
                // toggle active image
                if(e.target.closest(this.thumbSelector)) {
                    const clickedThumb = e.target.closest(this.thumbSelector);
                    const mainImage = gallery.querySelector(`${this.imageMainSelector} img`);

                    if(mainImage) {
                        // toggle active state
                        this.toggleActiveThumb(clickedThumb);

                        // toggle main image
                        this.toggleMainImage(clickedThumb, mainImage);
                    }
                }

                // open gallery in fullscreen
                if(e.target.closest(this.galleryFullscreenAction)) {
                    const button = e.target.closest(this.galleryFullscreenAction);
                    const activeImage = gallery.querySelector(`${this.imageListSelector} .is-active`);
                    const data = {
                        selected: activeImage ? activeImage.dataset.hkImage : 1
                    };

                    opaccAjaxPlugin.fetchAsynPostForm(button.dataset.url, data, this.showFullscreenGallery.bind(this), opaccAjaxPlugin.getDefaultErrorFnc.bind(this), true);
                }
            });
        });
    }

    /**
     * Show image gallery in fullscreen.
     * @param {Object} response response object
     */
    showFullscreenGallery(response) {
        if(response && response.success) {
            document.body.insertAdjacentHTML('beforeend', response.dataAsHtml);
            const gallery = document.querySelector(this.galleryFullscreenSelector);
            if(gallery) {
                gallery.classList.add('is-open');
                this.attachGalleryFullscreenEventListener(gallery);
            }
        }
    }

    /**
     * Attach event listeners for fullscreen gallery.
     * @param {Object} gallery fullscreen gallery
     */
    attachGalleryFullscreenEventListener(gallery) {
        gallery.addEventListener('click', e => {
            if(e.target.closest(this.closeFullscreenAction)) {
                gallery.remove();
            }

            // toggle active image
            if(e.target.closest(this.thumbSelector)) {
                const clickedThumb = e.target.closest(this.thumbSelector);
                const mainImage = gallery.querySelector(`${this.imageMainSelector} img`);

                if(mainImage) {
                    // toggle active state
                    this.toggleActiveThumb(clickedThumb);

                    // toggle main image
                    this.toggleMainImage(clickedThumb, mainImage);
                }
            }

            if (e.target.closest(this.galleryControlSelector)) {
                const button = e.target.closest(this.galleryControlSelector);
                const thumbs = gallery.querySelectorAll(this.thumbSelector);
                const activeThumb = gallery.querySelector(`${this.thumbSelector}.is-active`);
                const activeThumbIndex = +activeThumb.dataset.hkImage - 1;

                if (button.dataset.opDirection === "prev" && activeThumb !== thumbs[0]) {
                    const prevThumb = thumbs[activeThumbIndex - 1];
                    prevThumb.click();
                } else if(button.dataset.opDirection === "prev" && activeThumb == thumbs[0]) {
                    const prevThumb = thumbs[thumbs.length - 1];
                    prevThumb.click();
                }
                if (button.dataset.opDirection === "next" && activeThumb !== thumbs[thumbs.length - 1]) {
                    const nextThumb = thumbs[activeThumbIndex + 1];
                    nextThumb.click();
                } else if(button.dataset.opDirection === "next" && activeThumb == thumbs[thumbs.length - 1]) {
                    const nextThumb = thumbs[0];
                    nextThumb.click();
                }
            }
        });
    }

    /**
     * Toggle main image source.
     * @param {Object} clickedThumb clicked image thumbnail
     * @param {Object} mainImage main image
     */
    toggleMainImage(clickedThumb, mainImage) {
        const mainImageContainer = mainImage.closest(this.imageMainSelector);
        const imgContainer = mainImageContainer.querySelector('img');
        const iframeContainer = mainImageContainer.querySelector('iframe');
        if (clickedThumb.dataset.type === "video"){
            imgContainer.classList.add('is-hidden');
            if(iframeContainer) {
                iframeContainer.classList.remove('is-hidden');
            }
        } else {
            if(iframeContainer) {
                iframeContainer.classList.add('is-hidden');
            }
            imgContainer.classList.remove('is-hidden');
            const image = clickedThumb.querySelector('img');
            let imgSrc = '';
            if (image) {
                imgSrc = image.src.replace('_s_', '_l_');
            }
            mainImage.src = imgSrc != '' ? imgSrc : mainImage.src;
        }
    }

    /**
     * Toggle active image thumbnail.
     * @param {Object} clickedThumb clicked image thumbnail
     */
    toggleActiveThumb(clickedThumb) {
        const list = clickedThumb.closest(this.imageListSelector);
        if (list) {
            const currentActive = list.querySelector('.is-active');
            if (currentActive) {
                currentActive.classList.remove('is-active');
            }
            clickedThumb.classList.add('is-active');
        }
    }
}


new HKImageGallery();

